<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.bk {
  background-image: url(./assets/images/background2740d2.jpg);
  background-size: auto 100%;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/App.vue